import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";
import router from "@/router";

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
  subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URI + '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
// service.interceptors.response.use(
//   /**
//    * If you want to get http information such as headers or status
//    * Please return  response => response
//   */

//   /**
//    * Determine the request status by custom code
//    * Here is just an example
//    * You can also judge the status by HTTP Status Code
//    */
//   response => {
//     const res = response.data

//     return res
//   },
//   async error => {
//     const {status, data } = error.response
//     const originalRequest = error.config

//     if(status === 401 && data.message === 'Token has expired') {
//         const refresh = await store.dispatch('user/refresh')

//         // 2) Change Authorization header
//         originalRequest.headers['Authorization'] = 'Bearer ' + refresh
//         axios.defaults.headers.common['Authorization'] = 'Bearer ' + refresh

//         // 3) return originalRequest object with Axios.
//         return axios(originalRequest);
//     }
//     return Promise.reject(error)
//   }
// )

service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const {
      config,
      response: { status, data }
    } = error;
    const originalRequest = config;

    // Refresh token nolonger valid, logout
    if (
      status === 403 &&
      data.message === "Unauthorized"
    ) {

      store
        .dispatch("user/logout", {
          force: true
        })
        .then(() => {

          router.push("/login");
        });
    }

    return Promise.reject(error);
  }
);

export default service;
